export default function removeDiacritics(value: string) {
    return (
        value
            .toLowerCase()
            .normalize('NFD')
            // Replace all diacritic marks, except for å
            .replaceAll(/a[\u030a]/g, 'å')
            .replaceAll(/[\u0300-\u036f]/g, '')
            .normalize()
    );
}
